import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  EventEmitter,
  Input,
  Output,
  inject,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterLink, RouterLinkActive, type IsActiveMatchOptions } from "@angular/router";
import { EXACT_LINK_ACTIVE_OPTIONS } from "@core/consts/link-active-options.constants";
import { INDUCTION_HOME_ROUTE } from "@core/consts/assignment-page.constants";
import { CUSTOM_NAV_ICONS } from "@core/consts/custom-nav-icons.constants";
import { CERTIFICATES_ROUTE } from "@core/consts/certificates-routes.constants";
import { DomainService } from "@shared/services/domain/domain.service";
import {
  NgbOffcanvas,
  OffcanvasDismissReasons,
  NgbModal,
  NgbModalConfig,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { MyIcon } from "@shared/classes/my-icon";
import { Subject } from "rxjs";
import { SessionUserDataService } from "@shared/services/user-data/session-user-data.service";
import { UserAssignmentNavigationService } from "@core/services/user-assignment-navigation.service";
import { NotificationDataService } from "@shared/services/notification-data/notification-data.service";
import { PwaInstallService } from "@shared/services/pwa/pwa-install.service";
import { InstallAppButtonComponent } from "@shared/components/install-app-button/install-app-button.component";
import { SanitizeHtmlPipe } from "@shared/pipe/sanitize-html.pipe";
@Component({
  selector: "app-navbar",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  encapsulation: ViewEncapsulation.None,
  host: {
    "(window:resize)": "onResize($event)",
  },
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    NgbModule,
    TranslateModule,
    InstallAppButtonComponent,
    SanitizeHtmlPipe,
  ],
})
export class NavbarComponent {
  private readonly offcanvasService: NgbOffcanvas = inject(NgbOffcanvas);
  readonly modalService: NgbModal = inject(NgbModal);
  readonly modalConfig: NgbModalConfig = inject(NgbModalConfig);
  private readonly sessionUserDataService: SessionUserDataService = inject(SessionUserDataService);
  private readonly userAssignmentNavigation: UserAssignmentNavigationService = inject(UserAssignmentNavigationService);
  protected readonly notificationData: NotificationDataService = inject(NotificationDataService);
  protected readonly pwaInstall: PwaInstallService = inject(PwaInstallService);
  protected readonly domainService: DomainService = inject(DomainService);

  icon: MyIcon = new MyIcon();
  closeResult: string = "";
  modal!: NgbModalRef;
  notifications: number = 0;
  public totalUnreadNotifications: number = 0;
  @Input() hasUserQuery: boolean = false;
  @Output() emAction: EventEmitter<unknown> = new EventEmitter<unknown>();
  
  @Input() statistics: unknown;
  @Input() isEmptyStatistics!: boolean;

  private destroy$: Subject<void> = new Subject<void>();
  public isDesktop: boolean = false;

  readonly certificatesRoute: string = CERTIFICATES_ROUTE;
  readonly inductionRoute: string = INDUCTION_HOME_ROUTE;
  readonly inductionNavIconSvg: string = CUSTOM_NAV_ICONS.induction;
  readonly exactLinkActiveOptions: IsActiveMatchOptions = EXACT_LINK_ACTIVE_OPTIONS;

  public get homeRoute(): string {
    return this.userAssignmentNavigation.defaultHomeRoute(this.sessionUserDataService.user()?.assignmentType);
  }

  public openOffcanvas(content: object): void {
    this.offcanvasService
      .open(content, { panelClass: "bg-dark calibrate-bar-pers calibrate-bar" })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: unknown): string {
    if (reason === OffcanvasDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === OffcanvasDismissReasons.BACKDROP_CLICK) {
      return "by clicking on the backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  public openModal(content: unknown): void {
    this.modal = this.modalService.open(content, {
      ariaLabelledBy: "modal-basic-title",
      windowClass: "dark-modal",
      size: "sm",
    });
  }

  closeModal(): void {
    if (this.modal) {
      this.modal.close();
    }
  }

  public logout(): void {
    location.replace("/logout");
  }

  userResult(data: unknown): void {
    this.emAction.emit(data);
  }

  onResize(event: Event): void {
    this.isDesktop = ((event.target as Window | null)?.innerWidth ?? window.innerWidth) > 768;
  }

  ngOnInit(): void {
    this.modalConfig.backdrop = "static";
    this.modalConfig.keyboard = false;
    this.isDesktop = window.innerWidth > 768;

    this.notificationData.loadNotifications();


  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    window.removeEventListener('resize', () => {});
  }

  ngAfterViewInit(): void {}
}
